export default __webpack_public_path__ + "static/media/KOD0141-min.3f1564be.webp";